(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('roleService', roleService);

    /* @ngInject */
    function roleService($http, $q, exception, logger, coreService, $odataresource, $odata, config) {
        var service = {
            getDefaultRole: getDefaultRole,
            getRoleFields: getRoleFields,
            getModalOptions: getModalOptions,
            getRoles: getRoles,
            getNotAssignedRoles: getNotAssignedRoles,
            saveRole: saveRole,
            deleteRole: deleteRole,
            getRolesByApplication: getRolesByApplication,
            getAllRolesByApplication: getAllRolesByApplication,
            getODataResource: getODataResource,
            getTableConfig: getTableConfig,
            getRolesForApplicationName: getRolesForApplicationName,
            getRolesByRoleName: getRolesByRoleName,
            getRolesByApplicationId: getRolesByApplicationId
        };

        activate();

        return service;

        function activate() {
        }

        function getODataResource() {
            return $odataresource(config.apiUrl + 'odata/Roles',
                {},
                {},
                {
                    odatakey: 'RoleId',
                    isodatav4: true
                });
        }

        function getDefaultRole(applictionID) {
            return {
                RoleName: '',
                ApplicationId: applictionID
            };
        }

        function getTableConfig() {
            return {
                columns: [
                    {
                        id: 'RoleName',
                        displayName: 'Role Name',
                        ODataKey: 'RoleName',
                        type: 'match'
                    },
                    {
                        id: 'Application',
                        displayName: 'Application Name',
                        ODataKey: 'Application/ApplicationName',
                        type: 'subItem'
                    }
                ],
                actions: []
            };
        }

        function getRoleFields(applicationID, applications) {
            var userFields = [
                {
                    key: 'RoleName',
                    type: 'input',
                    templateOptions: {
                        type: 'text',
                        label: 'Role Name',
                        placeholder: 'Enter Role Name',
                        required: true,
                        maxlength: 100
                    }
                },
                {
                    key: 'IsVisible',
                    type: 'checkbox',
                    templateOptions: {
                        label: 'Is Role Visible'
                    }
                },
                {
                    key: 'ApplicationId',
                    type: 'ui-select-single',
                    defaultValue: applicationID,
                    ngModelAttrs: {
                        customAttrVal: {
                            attribute: 'disabled'
                        }
                    },
                    templateOptions: {
                        options: applications,
                        disabled: true,
                        optionsAttr: 'bs-options',
                        label: 'Application',
                        ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                        valueProp: 'ApplicationId',
                        labelProp: 'ApplicationName',
                        placeholder: 'Select Application Type'
                    }
                }
            ];
            return userFields;
        }

        function preProcessRolesOData(tableState) {
            var query = getODataResource().odata();

            if (!!tableState) {
                coreService.processODataFilters(query, tableState.search.predicateObject, getTableConfig().columns);
                coreService.processODataPage(query, tableState.pagination);
            } else {
                tableState = { sort: {} };
            }
            tableState.sort = tableState.sort.predicate ? tableState.sort : { predicate: 'RoleName', reverse: false };
            coreService.processODataSort(query, tableState.sort);

            return query;
        }

        function postProcessRolesOData(query) {
            return query
                .expand('Application')
                .withInlineCount()
                .query()
                .$promise;
        }

        function getRoles(tableState) {
            return postProcessRolesOData(
                preProcessRolesOData(tableState));
        }

        function getRolesForApplicationName(applicationShortName) {
            var query = service.getODataResource().odata();

            return query
                .filter('Application/ShortName', applicationShortName)
                .select('RoleId', 'RoleName')
                .query()
                .$promise;
        }

        function getAllRolesByApplication(applicationID) {
            var query = service.getODataResource().odata();
            query.filter('ApplicationId', new $odata.Value(parseInt(applicationID).toString(), 'Int32'));
            return query
                .expand('Application')
                .withInlineCount()
                .query()
                .$promise;
        }

        function getRolesByApplication(applicationID, tableState) {
            return postProcessRolesOData(
                preProcessRolesOData(tableState)
                    .filter('ApplicationId', new $odata.Value(parseInt(applicationID).toString(), 'Int32')));
        }

        function saveRole(applicationRole) {
            return coreService.httpAccountsPost('role', applicationRole);
        }

        function deleteRole(applicationRole) {
            var url = 'Role/';
            url = url + encodeURIComponent(applicationRole.RoleId);
            return coreService.httpAccountsPost(url, applicationRole);
        }

        function getNotAssignedRoles(userID) {
            var url = 'Role/';
            url = url + encodeURIComponent(userID);
            url = url + '/NotAssigned';
            return coreService.httpAccountsGet(url);
        }

        function getModalOptions() {
            return {
                animation: true,
                templateUrl: 'app/application/role/dashboard/modal/role.modal.html',
                controllerAs: 'vm'
            };
        }

        function getRolesByRoleName(roleName) {
            var role = getODataResource();
            var query = role.odata();

            return query
                .filter('RoleName', roleName)
                .withInlineCount()
                .query()
                .$promise;
        }

        function getRolesByApplicationId(applicationId) {
            var role = getODataResource();
            var query = role.odata();

            return query
                .filter('ApplicationId', applicationId)
                .withInlineCount()
                .query()
                .$promise;
        }
    }
})();
